import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ILoopDetail } from '../../../../../widget/interfaces/total-extraction';
import { TotalExtractionService } from '../../../../services/total-extraction/total-extraction.service';
import { ParameterHandlerService } from '../../../../../../../../projects/common/src/app/services/parameter-handler.service';
import { FirstLastLoopDetailTableComponent } from '../first-last-loop-detail-table/first-last-loop-detail-table.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-first-last-loop-modal',
  templateUrl: './first-last-loop-modal.component.html',
  styleUrls: ['./first-last-loop-modal.component.scss'],
})
export class FirstLastLoopModalComponent {
  @Input() public firstLoop: ILoopDetail;
  @Input() public lastLoop: ILoopDetail;

  constructor(
    public modalService: NgbModal,
    public parameterService: ParameterHandlerService,
    public totalExtractionSvc: TotalExtractionService,
  ) {}

  public open(title: string, loop: ILoopDetail): void {
    if (parseFloat(loop.loopQtyInPeriod) > 0) {
      const inputDate = this.parameterService.parameters?.item('date')?.value as string;
      const subtitle = this.buildModalSubtitle(loop.shiftId.toString(), inputDate);

      const modalRef = this.modalService.open(FirstLastLoopDetailTableComponent, {
        centered: true,
        size: 'lg',
      });

      // send input properties to FirstLastLoopDetailTableComponent
      modalRef.componentInstance.loopDetailModalTitle = title;
      modalRef.componentInstance.loopDetailModalSubtitle = subtitle;
      modalRef.componentInstance.shiftCharDetail = loop.shiftName;
      modalRef.componentInstance.inputDate = inputDate;
      modalRef.componentInstance.shiftId = loop.shiftId;
    }
  }

  public buildModalSubtitle(shiftId: string, inputDate: string) {
    const shiftCollection = this.parameterService.parameters.item('shift-collection')?.value as Array<any>;

    const shiftObj = shiftCollection.find((shift) => shift.shiftId === shiftId);
    const startTime = `${this.fixTimePresentation(shiftObj.startTime.hours)}:${this.fixTimePresentation(shiftObj.startTime.minutes)}`;
    const endTime = `${this.fixTimePresentation(shiftObj.endTime.hours)}:${this.fixTimePresentation(shiftObj.endTime.minutes)}`;
    const dateArray = inputDate.split('-');
    const fomattedDate = `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`;
    const dateFormated =
      environment?.lang === 'en-us' ? `${fomattedDate} from ${startTime} to ${endTime}` : `${fomattedDate} de ${startTime} a ${endTime}`;
    return dateFormated;
  }

  public fixTimePresentation(time: number) {
    if (time < 10) {
      return `0${time}`;
    }

    return time;
  }
}
